var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-component"},[_c('router-link',{attrs:{"to":{ name: _vm.page, hash: `#${_vm.anchor}`}},nativeOn:{"click":function($event){return _vm.anchorHashCheck.apply(null, arguments)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }